import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollToPlugin } from "../vendor/gsap-bonus-umd/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    this.DOM.view.addEventListener('click',()=>{
      gsap.to(Env.$window, { scrollTo: { y : 0 } , ease: 'cubic.inOut' , duration: 1 })
    })

  }

  unmount()
  {

  }
}
